export default "__VITE_ASSET__3762b65c__"